import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(public dialog: MatDialog) {}
  openDialog(component: any, data?: any, autoFocus = true, width='auto', disableClose = false) {
    return this.dialog.open(component, {
      height: 'auto',
      width : width,
      data: { data },
      autoFocus: autoFocus,
      disableClose: disableClose
    });
  }
}
